import { render, staticRenderFns } from "./TheNotice.vue?vue&type=template&id=49a7cc67&scoped=true&lang=pug&"
import script from "./TheNotice.vue?vue&type=script&lang=js&"
export * from "./TheNotice.vue?vue&type=script&lang=js&"
import style0 from "./TheNotice.vue?vue&type=style&index=0&id=49a7cc67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7cc67",
  null
  
)

export default component.exports